import React from 'react';
import dompurify from 'dompurify';

export const VoteBiography = ({ bioBallotOption }) => {
    const sanitizer = dompurify.sanitize;

    return (
        <div className="flex items-start">
            {bioBallotOption.ballotOptionPhotoId &&
                <img className="max-w-[200px] mr-4 object-contain" src={`/vote/bioImg${window.location.search}`} alt={bioBallotOption.ballotOptionName} />
            }
            <div className="flex-1">
                <h2 className="block font-medium mb-4">{bioBallotOption.ballotOptionName}</h2>
                {bioBallotOption.ballotOptionSubName && <span className="block mb-4">{bioBallotOption.ballotOptionSubName}</span>}
                <span dangerouslySetInnerHTML={{ __html: sanitizer(bioBallotOption.ballotOptionDescription) }} />
            </div>
        </div>
    );
}